// renew
   console.log("start")

const form = document.getElementById('renew-verify-form');
async function renewVerify(event){
  // 阻止默认刷新事件
  event.preventDefault();
  event.stopPropagation();
  // 获取相应的dom结构
  const VerifyingSection = document.getElementById('shopify-section-template--25052355068184__rich_text_mdqhE8');
  const errorSection = document.getElementById('shopify-section-template--25052355068184__rich_text_tG7xG9');
  const codeSection = document.getElementById('shopify-section-template--25052355068184__rich_text_pemGqU');
  const codeid = document.getElementById('code-id');
  const deviceId = document.getElementById('Device-ID').value.trim();
  const accountId = document.getElementById('Birdfy-Account-ID').value.trim();
  const desId = document.getElementById('des-id');
  

  // 三个状态初始化
  errorSection.style.display = 'none'
  codeSection.style.display = 'none'
  VerifyingSection.style.display = 'block'
  

  if(deviceId && accountId) {
    const body ={
      deviceId:deviceId,
      accountId:accountId
     }
    try{
      const response = await  fetch('https://capiv3.nvts.co/generateShopifyDiscount', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Connection': 'keep-alive'
          },
          body: JSON.stringify(body)
      });
      
      const data = await response.json();
      console.log("data",data)
      // 处理逻辑
      var Minimum = ""
      if(data.usagePeriod == "1"){
         Minimum = "100"
       } else if(data.usagePeriod == "2"){
        Minimum = "200"
       }else if(data.usagePeriod == "3"){
        Minimum = "300"
       }else{
        Minimum = "400"
        }
      if(data.state== 1 || data.state== 2){
        codeid.textContent = data.discountCode
        // 
        desId.innerHTML= "Your discount: $"+ data.couponAmount + "<br>" +  "Minimum Purchase: $" + Minimum + "<br>Copy the code and use it at checkout!"
        VerifyingSection.style.display = 'none'
        codeSection.style.display = 'block'
        errorSection.style.display = 'none'
      }else {
        VerifyingSection.style.display = 'none'
        errorSection.style.display = 'block'
        codeSection.style.display = 'none'
      } 
    }
    catch (error) {
        console.error('提交失败:', error);
    }
   }
  
  }
form.addEventListener('submit', renewVerify);
